import React, { useEffect, useState } from "react";
import API_BASE_URL from "./RestAPI";
import { showSuccessToast, showErrorToast } from "../constants/ToastService.js";

const CompanyDetails = () => {
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        fetch(`${API_BASE_URL}core/company/`)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success" && data.data.length > 0) {
                    setCompany(data.data[0]);
                    setFormData(data.data[0]);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching company details:", error);
                setLoading(false);
            });
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        fetch(`${API_BASE_URL}core/company/`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    setCompany(data);
                    showSuccessToast(data.message);
                } else if (data.status === "fail") {
                    showErrorToast(data.message);
                }
            })
            .catch(error => console.error("Error updating company:", error));
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Company Details</h1>
            {loading ? (
                <p style={styles.loading}>Loading...</p>
            ) : company ? (
                <div style={styles.form}>
                    <div style={styles.leftColumn}>
                        <label style={styles.label}>Company Name:</label>
                        <input type="text" name="company_name" value={formData.company_name || ""} onChange={handleChange} style={styles.input} />

                        <label style={styles.label}>Short Name:</label>
                        <input type="text" name="short_name" value={formData.short_name || ""} onChange={handleChange} style={styles.input} />

                        <label style={styles.label}>GST Number:</label>
                        <input type="text" name="gst_number" value={formData.gst_number || ""} onChange={handleChange} style={styles.input} />

                    </div>

                    <div style={styles.rightColumn}>
                        <label style={styles.label}>Address:</label>
                        <textarea name="address" value={formData.address || ""} onChange={handleChange} style={styles.textarea}></textarea>

                        <label style={styles.label}>Mobile Number:</label>
                        <input type="tel"  value={formData.mobile_number || null} name="mobile_number" pattern="[0-9]{10}" maxlength="10" minlength="10"onChange={handleChange} style={styles.input} />
                    </div>

                    <button className="save-btn" onClick={handleSave} style={styles.button}>Save</button>
                </div>
            ) : (
                <p style={styles.error}>Company details not available.</p>
            )}
        </div>
    );
};

const styles = {
    container: {
        padding: "20px 0px",
        color: "#e0e0e0",
        backgroundColor: "#121212",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    title: {
        fontSize: "28px",
        marginBottom: "20px",
        fontWeight: "600",
        color: "#fff",
    },
    loading: {
        fontSize: "18px",
        color: "#bbb",
    },
    form: {
        display: "flex",
        flexWrap: "wrap",
        width: "80%",
        justifyContent: "space-between",
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: "#1e1e1e",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
    },
    leftColumn: {
        width: "48%",
        display: "flex",
        flexDirection: "column",
    },
    rightColumn: {
        width: "48%",
        display: "flex",
        flexDirection: "column",
    },
    label: {
        fontSize: "14px",
        fontWeight: "500",
        marginBottom: "5px",
        color: "#ccc",
    },
    input: {
        padding: "10px",
        fontSize: "14px",
        borderRadius: "5px",
        border: "1px solid #444",
        backgroundColor: "#2a2a2a",
        color: "#fff",
        marginBottom: "15px",
        outline: "none",
    },
    textarea: {
        padding: "10px",
        fontSize: "14px",
        borderRadius: "5px",
        border: "1px solid #444",
        backgroundColor: "#2a2a2a",
        color: "#fff",
        minHeight: "90px",
        marginBottom: "15px",
        outline: "none",
    },
    button: {
        width: "100%",
        padding: "12px",
        fontSize: "16px",
        borderRadius: "5px",
        border: "none",
        color: "#fff",
        fontWeight: "bold",
        cursor: "pointer",
        transition: "0.3s",
        marginTop: "20px",
        border: '2px solid white',
    },
    buttonHover: {
        backgroundColor: "#0056b3",
    },
    error: {
        fontSize: "16px",
        color: "red",
    },
};

export default CompanyDetails;
